import React from 'react';
import {
  BACKGROUND_PATTERN_OPTIONS,
  getBackgroundPatternStyle,
} from '../utils/backgroundPatterns';

const BackgroundPatternPicker = ({
  pattern,
  opacity,
  previewBackground,
  previewForeground,
  onPatternChange,
  onOpacityChange,
}) => {
  const normalizedOpacity = Number.isFinite(Number(opacity)) ? Number(opacity) : 100;

  return (
    <div
      className="background-pattern-modal"
      onClick={(event) => event.stopPropagation()}
      role="dialog"
      aria-label="Background pattern picker"
    >
      <div className="background-pattern-options">
        {BACKGROUND_PATTERN_OPTIONS.map((option) => (
          <button
            key={option.id}
            type="button"
            className={`background-pattern-option${pattern === option.id ? ' is-selected' : ''}`}
            aria-label={option.label}
            aria-pressed={pattern === option.id}
            onClick={() => onPatternChange(option.id)}
            title={option.label}
          >
            <span
              className="background-pattern-option-preview"
              style={getBackgroundPatternStyle({
                pattern: option.id,
                opacity: normalizedOpacity,
                backgroundColor: previewBackground,
                foregroundColor: previewForeground,
              })}
            />
          </button>
        ))}
      </div>

      <div className="background-pattern-opacity">
        <div className="background-pattern-opacity-label">Opacity</div>
        <div className="background-pattern-opacity-controls">
          <input
            type="range"
            min="0"
            max="100"
            step="1"
            value={normalizedOpacity}
            onChange={(event) => onOpacityChange(Number(event.target.value))}
            className="background-pattern-opacity-slider"
            style={{ '--slider-progress': `${normalizedOpacity}%` }}
            aria-label="Background pattern opacity"
          />
          <span className="background-pattern-opacity-value">{normalizedOpacity}%</span>
        </div>
      </div>
    </div>
  );
};

export default BackgroundPatternPicker;
